import { TApplicationState } from '../../types/redux';

export function getPriceForObjectFromDeveloperDisplay(state: TApplicationState) {
  const {
    newbuilding: { priceForObjectFromDeveloperDisplay },
  } = state;

  return priceForObjectFromDeveloperDisplay;
}
